import { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import Loading from "../Component/Loding.jsx";
import moment from "moment";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import * as Common from "../../Common/common.js";
import mainBg from "../../assets/img/bg-esg-05.jpg";
import modalIcon01 from "../../assets/img/humanMgmt-modal-icon01.png";
import modalIcon02 from "../../assets/img/humanMgmt-modal-icon02.png";
import modalIcon03 from "../../assets/img/humanMgmt-modal-icon03.png";

import { createPopup } from "../../Common/common.js"


function EthicalMgmt() {
    // 권한 체크
    const authCk = Common.fn_authChek();

		//모달
			const [isModalOpen, setIsModalOpen] = useState(false);
			// 스크롤 막기 처리
			useEffect(() => {
				if (isModalOpen) {
					document.body.style.overflow = "hidden";
				} else {
					document.body.style.overflow = "auto";
				}

				return () => {
					document.body.style.overflow = "auto";
				};
			}, [isModalOpen]);


    // 화면 이동을 위한 네비게이터 설정
		const navigate = useNavigate();
		const [isLoading, setIsLoading] = useState(false);

		// 일반 또는 관리자 header 설정
		const { argInfo } = useContext(ArgContext);
		const isAdmin = argInfo?.role === 'admin';

    // 파일 데이터
    const [imgFile, setImgFile] = useState([]);

		//제보일
		const [emailInfo, setEmailInfo] = useState({
          gubun: "eth"
        , registDate: moment(new Date()).format("YYYY-MM-DD") 
        , registName: ""
        , registTelNo: ""
        , registMail: ""
        , registTitle: ""
        , registContent: ""
				, registRequire: ""
    });

    // 파일 정보 제외한 data 변경 값 set
    const handleChange = (e) => {
		const { value, name } = e.target;
		setEmailInfo({
			...emailInfo, // 기존 객체 복사
			[name]: value, // name 키를 가진 값을 value로 설정
		});
	}

    // 파일 변경 데이터 set
    const handleChangeFile = (event) => {
        setImgFile(event.target.files); 
    }

    const handleSuccess = () => {
        const title = '접수 완료';
        const cont = '4주 이내에 확인 및 조치하여<br />결과를 회신드리겠습니다.';
        // createPopup(title,cont);
        //setShowPopup(true);
        setIsLoading(false);
    };

	//신고하기
	const fn_report = () => {
			setIsLoading(true);
			Common.fn_send(imgFile, emailInfo, "/ethicalMgmt", (success)=> {
					setIsLoading(false);
					if (success) {
						setIsModalOpen(false);
					}
				})
					.then(response => {
							//console.log('Success:', response);
							handleSuccess();

					})
					.catch(error => {
							//console.error('Error:', error);
							setIsLoading(false);
					});
		}

				//파일다운로드
				const downloadFile = async () => {
					const response = await fetch("/download/ethicalReport");
					const blob = await response.blob();
				
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.href = url;
					a.download = "위피아_윤리헌장_및_윤리규범.pdf";
					a.click();
					a.remove();
					window.URL.revokeObjectURL(url);
				};
    return (
		<>
       
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
		
			{/* <!-- 메인 미이지 + 슬로건 --> */}
				<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
						<div className="textBox">
							<h2>윤리경영</h2>
							<p>위피아는 지속가능한 경영을 위해 사회적 역할과 책임을 다하고 신뢰받는 기업이 되기 위해 노력합니다.</p>
						</div>
						<SubMenu />
				</section>

			{/* 윤리경영 */}
			<section className="esg-visoinObj ethical-mgmt ">
				<div className="container-auto sec-mt title-box">
						<h3 className="sub-title">윤리경영</h3>
						<p className="sub-text">
							위피아는 투명하고 공정한 경영활동을 통해 청렴한 기업문화를 정착하고 다양한 이해관계자로부터 신뢰와 존경을 받는 기업이 되기 위해 노력합니다.
						</p>
				</div>
				<div className="bg-blue sec-py ">
					<div className="container-auto safety-mgmt">
						<div className="sub-title-box">
							<h4 className="title">적용 범위 및 위피아 5대 윤리 헌장</h4>
							<p className="text">위피아의 모든 임직원은 법규를 준수하는 동시에 본 윤리헌장 및 윤리규범에 따라 업무를 수행해야 하며, 위피아는 모든 경영활동에서 의사결정과 행동의 판단 기준으로 삼는다.</p>
						</div>
						<ul className="enviro-list">
							<li>
								<p className="num">01</p>
								<p className="text">우리는 정직과 공정의 신념으로 올바른 가치관을 확립하고 끊임없는 자기개발과 공정한 직무수행을 통해 주어진 사명을 완수한다.</p>
							</li>
							<li>
								<p className="num">02</p>
								<p className="text">우리는 모든 임직원을 한 인간으로서 존중하고 능력과 업적에 따라 공정하게 대우하며 임직원의 창의성이 충분히 발휘되도록 노력한다.</p>
							</li>
							<li>
								<p className="num">03</p>
								<p className="text">우리는 모든 사업활동에서 관계법규를 준수하며, 정당한 방법과 실력으로 경쟁의 우위를 확보한다.</p>
							</li>
							<li>
								<p className="num">04</p>
								<p className="text">우리는 고객의 의견을 항상 존중하고, 고객에게 도움이 되는 가치를 끊임없이 창출하여 제공함으로써 고객으로부터 신뢰를 확보한다.</p>
							</li>
							<li>
								<p className="num">05</p>
								<p className="text">우리는 합리적인 사업전개를 통해 건실한 기업으로 성장함으로써 다양한 이해관계자가 함께 번영할 수 있는 지속 가능한 발전을 구현하는데 기여한다.</p>
							</li>
						</ul>
						<div className="signWrap">
							<p className="ceo">㈜위피아 대표이사 김용연 <span className="sign">대표이사 사인</span></p>
						</div>
					</div>
				</div>
			</section>

			<section className="container-auto sec-my ">
				<h3 className="sub-title">윤리위반 제보</h3>
				<p className="sub-text">임직원의 불공정한 업무처리, 부당한 요구 등 각종 위법 행위에 대한 제보를 받고 있습니다. 신고 및 제보를 해주신 분이 불이익을 당하지 않도록 철저한 비공개 방식으로 처리됩니다.</p>

				<ul className="ethical-btn btnWrap">
					{/* <li><button onClick={()=>{Common.fn_fileDownload("eth")}}>위피아 윤리헌장 및 윤리규범 다운로드</button></li> */}
					<li>
						{/* <button onClick={downloadFile}>위피아 윤리헌장 및 윤리규범 다운로드</button> */}
						<button onClick={downloadFile}>위피아 윤리헌장 및 윤리규범 다운로드</button>
					</li>
					
					<li><button className="ethical-mgmt-modalBtn" onClick={() => setIsModalOpen(true)}>윤리규범 위반 제보</button></li>
				</ul>
			</section>
		</main>

		{/* 윤리규범 위반 신고 및 제보 모달 */}
		{isModalOpen && (
		<div className="modalWrap human-mgmt-modal subpage-modal">
			<div className="modal-inner">
				<div className="modal-title"> 
					<h3 className="title">윤리규범 위반 신고 및 제보</h3>
					<button className="close-btn" onClick={() => setIsModalOpen(false)}>닫기</button>
				</div>
				<div className="modal-textBox scroll">
					<h4 className="tit">윤리규범 위반 신고</h4>
					<p className="txt">
						- 위피아는 임직원의 윤리규범 위반 사실에 대해 신고합니다.
						- 사실에 근거하지 않은 비방, 개인사생활과 관련한 사항은 조사 대상에서 제외하며, 조사시 추가 필요사항을 요청드릴 수 있습니다.
					</p>

					<section className="report-box">
						<h4 className="tit">제보방법</h4>
						<ul className="list">
							<li>
								<img src={modalIcon01} className="list-icon" />
								<div className="textArea">
									<p className="title">우편신고</p>
									<p className="text">서울특별시 영등포구 경인로 775, 1-507 (문래동3가 , 에이스하이테크시티)</p>
								</div>
							</li>
							<li>
								<img src={modalIcon02} className="list-icon" />
								<div className="textArea">
									<p className="title">유선신고</p>
									<p className="text">02-2038-8311</p>
								</div>
							</li>
							<li>
								<img src={modalIcon03} className="list-icon" />
								<div className="textArea">
									<p className="title">온라인신고</p>
									<p className="text">홈페이지 : www.wipia.co.kr</p>
								</div>
							</li>
						</ul>
					</section>
					<section className="report-table">
						<h4 className="tit">윤리규범 위반 제보</h4>
						<p className="txt">
							※ 위피아는 신고자의 신분을 최우선으로 보호합니다. <br />
							※ 윤리규범 제보를 위해 수집된 개인정보는 목적 외의 용도로 사용하지 않겠습니다. <br />
							※ 사실에 근거하지 않은 비방, 개인사생활과 관련한 사항은 조사 대상에서 제외하며, 조사시 추가 필요사항을 요청드릴 수 있습니다.
						</p>
						
						<div className="tableWrap">
							<form className="needs-validation" noValidate>

								<div className="tableBox">
									<div className="list-ly02">
										<p className="title">제보일</p>
										<div className="text"><input type="text" id="fn" value={emailInfo.registDate} required disabled/></div>
										<p className="title">제보자 메일</p>
										<div className="text"><input type="text" name="registMail" onChange={handleChange} required/></div>
									</div>

									<div className="list-ly02">
										<p className="title">제보자 성명</p>
										<div className="text"><input type="text" name="registName" onChange={handleChange} required/></div>
										<p className="title">연락처</p>
										<div className="text"><input type="text" name="registTelNo" onChange={handleChange}/></div>
									</div>

									<div className="list-ly01">
										<p className="title">제목</p>
										<div className="text"><input type="text" name="registTitle" onChange={handleChange}/></div>
									</div>
									<div className="list-ly01">
										<p className="title">내용</p>
										<div className="text"><textarea type="text" name="registContent" onChange={handleChange} /></div>
									</div>
									<div className="list-ly01">
										<p className="title">요구사항</p>
										<div className="text"><textarea type="text" name="registRequire" onChange={handleChange} /></div>
									</div>
									<div className="list-ly01">
										<p className="title">증빙(선택)</p>
										<div className="text"><input type="file" className="rounded-start" onChange={handleChangeFile} multiple/></div>
									</div>
								</div>
								
								<button type="button" className="submit-btn" onClick={()=>{fn_report()}}>신고하기</button>
							</form>
						</div>
					</section>
					
				</div>
			</div>
			<div className="bg-b" onClick={() => setIsModalOpen(false)}></div>
		</div>
		)}
	<Footer />
	<Loading active={isLoading}/>

        </>
    )
}

export default EthicalMgmt;